import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shield-save",
  "use": "shield-save-usage",
  "viewBox": "0 0 16.45 20",
  "content": "<symbol viewBox=\"0 0 16.45 20\" id=\"shield-save\"><title>shield-save</title><path d=\"M18.21,2.9h-.81a11.59,11.59,0,0,1-3.72-.81A17.37,17.37,0,0,1,10.48.36L10,0,9.51.36A16,16,0,0,1,6.32,2.08a11.64,11.64,0,0,1-3.72.81H1.77v8.41C1.77,15.54,7.12,20,10,20s8.23-4.46,8.23-8.69Zm-3.68,7.71h-4v2.53a2,2,0,1,1-3.91,0,.47.47,0,0,1,.95,0,1,1,0,1,0,2,0V10.61h-4a.48.48,0,0,1-.47-.47A4.91,4.91,0,0,1,9.62,5.25V4.94a.47.47,0,1,1,.95,0v.32A4.9,4.9,0,0,1,15,10.14a.47.47,0,0,1-.47.47Zm0,0\" transform=\"translate(-1.77)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/shield-save.svg
// module id = IH71
// module chunks = 264